var login_form = document.querySelector('.login-form');
var recover_form =  document.querySelector('.recover-form');
if(login_form &&  recover_form){
  document.querySelector('.enable-login').addEventListener('click',function(e){
    e.preventDefault();
    login_form.classList.remove('hide-form');
    recover_form.classList.add('hide-form');
  });
  document.querySelector('.enable-forgot').addEventListener('click',function(e){
    e.preventDefault();
    login_form.classList.add('hide-form');
    recover_form.classList.remove('hide-form');
  });
}
document.querySelectorAll('.edit-address-button').forEach(function(editbutton){
  editbutton.addEventListener('click',function(e){
    e.preventDefault();
    var address_id = this.dataset.addressid;
    document.querySelectorAll('.address-edit-form').forEach(function(editformdiv){
      if(editformdiv.classList.contains('active-form') && editformdiv.dataset.id != address_id){
        editformdiv.classList.remove('active-form');
      }
    });
    document.querySelector('[data-id="'+address_id+'"]').classList.toggle('active-form');
  });
});
if(document.querySelector('#AddressCountryNew')){
  new Shopify.CountryProvinceSelector('AddressCountryNew', 'AddressProvinceNew', {
    hideElement: 'AddressProvinceContainerNew'
  });
  document.querySelectorAll('[data-address-country-select]').forEach((select) => {
    const formId = select.dataset.formId;
    new Shopify.CountryProvinceSelector(`AddressCountry_${formId}`, `AddressProvince_${formId}`, {
      hideElement: `AddressProvinceContainer_${formId}`
    });
  });
}
function handleDestroyClick(e) {
  e.preventDefault();

  const destroyId = this.dataset.destroy;
  console.log(destroyId);

  fetch('/account/addresses/' + destroyId, {
    method: 'POST',
    headers: {
      'Content-Type': 'application/x-www-form-urlencoded',
      'X-Requested-With': 'XMLHttpRequest',
      'X-CSRF-Token': document.querySelector('meta[name=csrf-token]')?.content || ''
    },
    body: new URLSearchParams({ _method: 'delete' })
  })
  .then(response => {
    if (response.ok) {
      const url = window.location.href;
      fetch(url)
        .then(response => response.text())
        .then(html => {
          const parser = new DOMParser();
          const doc = parser.parseFromString(html, 'text/html');

          if (doc.querySelector('.address-part') && document.querySelector('.address-part')) {
            document.querySelector('.address-part').innerHTML = doc.querySelector('.address-part').innerHTML;
          }
          if (doc.querySelector('.address-wrapper') && document.querySelector('.address-wrapper')) {
            document.querySelector('.address-wrapper').innerHTML = doc.querySelector('.address-wrapper').innerHTML;
          }

          bindAddressEvents();
        })
        .catch(error => {
          console.error('Error fetching updated HTML:', error);
        });
    }
  })
  .catch(error => {
    console.error('Error during address delete:', error);
  });
}

function openNewAddressForm() {
  const addressForm = document.querySelector('#address_form_new');
  const addBtn = document.querySelector('.add-address');
  const nonAddress = document.querySelector('.non-address');

  if (addressForm) {
    addressForm.classList.add('active-open-form');
  }

  if (addBtn) {
    addBtn.style.display = 'none';
  }

  if (nonAddress) {
    nonAddress.style.display = 'none';
  }
}

function bindAddressEvents() {
  document.querySelectorAll('.destroy_button').forEach(button => {
    button.removeEventListener('click', handleDestroyClick);
    button.addEventListener('click', handleDestroyClick);
  });

  const addButton = document.querySelector('.add-address');
  if (addButton) {
    addButton.removeEventListener('click', openNewAddressForm);
    addButton.addEventListener('click', openNewAddressForm);
  }

  document.querySelector('.add-address-new')?.addEventListener('click', function () {
    const targetTab = document.querySelector('.tab[data-index="3"]');
    if (targetTab) {
      targetTab.click();

      setTimeout(() => {
        const addAddressBtn = document.querySelector('.add-address');
        if (addAddressBtn) addAddressBtn.click();
      }, 50);
    }
  });
}

document.addEventListener('DOMContentLoaded', function () {
  bindAddressEvents();
});
if(document.querySelector('.account-link')){
  document.querySelector('.account-link').addEventListener('click',function(e){
    document.querySelector('.account-page-active').classList.add('active');
    document.querySelector('.account-left').style.display = 'none';
  });
}
// if(document.querySelector('.add-address')){
//   document.querySelector('.add-address').addEventListener('click',function(e){
//     document.getElementById('address_form_new').classList.toggle('active-open-form');
//   });
// }

